const PERCENT = 100;

/**
 * Position of `value` between `lowest` and `highest` in percent, as TV
 * Std.stoch: where it cannot be calculated (a flat window: 0 / 0) it keeps
 * the previous value, NaN before the first one (Stochastic, Schaff Trend Cycle).
 *
 * @param {number} value
 * @param {number} highest
 * @param {number} lowest
 * @param {number} previous - the result at the bar before
 * @returns {number}
 */
export const stochasticAt = (value, highest, lowest, previous) => {
  const position = (PERCENT * (value - lowest)) / (highest - lowest);

  if (!Number.isNaN(position)) return position;

  return previous === undefined ? NaN : previous;
};
